export default __webpack_public_path__ + "static/media/Bandhavgarh_National_Park.ec85cfa3.jpg";